export const environment = {
  production: true,
  // url: 'https://mdcapitalapi.desarrolloef.com/api',
  //url: 'https://api.mdcapital.com.co/api',
  url_datacredito: 'https://apidtc.bakna.co/api',
  url: 'https://api.bakna.co/api',
  datapublickey: 'pub_prod_UY6CWm20PpGE9td0t9HSsCjK7e3PJy08',
  // urlPagina: 'https://mdcapital.desarrolloef.com/account/pago',
  // urlPagina: 'http://localhost:4200/account/pago',
  urlPagina: 'https://app.bakna.co/account/pago',
  urlDocumentos: 'https://baknaapp.s3.us-east-2.amazonaws.com/',
  Authenticate: '/Authenticate',
  login: '/login',
  social: '/social',
  forgotPassword: '/forgotPassword',
  validateToken: '/validateToken',
  resetPassword: '/resetPassword',
  refresh: '/refresh',
  logout: '/logout',

  User: '/User',
  Customer: '/Customer',
  Credit: '/Credit',
  Marketplace: '/Marketplace',

  getDelayed: '/getDelayed',
  calculateCredit: '/calculateCredit',
  getDataCredito: '/getDatacredito',
  getCollectionPayments: '/getCollectionPayments',
  getCustomersByUser: '/getCustomersByUser',

  File: '/File',
  delete: '/delete',

  Report: '/Report',
  getCounters: '/getCounters',

  Pay: '/Pay',
  getPendingPayments: '/getPendingPayments',
  getPayments: '/getPayments',
  getTransactions: '/getTransactions',
  getTransactionsCobre: '/getAllTransaction',
  getTransactionsCobreByUser: '/getTransactionByUser',
  approveTask: '/approveTask',
  Settings: '/Settings',
  Wompi: '/Wompi',
  Cobre: '/Cobre',
  createPayment: '/createPayment',

  usersChild: '/UserChild',

  get: '/get',
  getAll: '/getAll',
  create: '/create',
  update: '/update',
  disable: '/disable',
  set: '/set',

  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  facebookAppId: '1377777427811018',
  googleClientId: '821234367492-fdcrpnl161bk03mpjnm5cp276rpt4gcf.apps.googleusercontent.com',
};
